import React from "react";
import { motion } from "framer-motion";
import { initialHPTVariants } from "./variants";
import ProgressiveBackgroundImg from "../ProgressiveBackgroundImg/ProgressiveBackgroundImg";
import { primaryInput } from "detect-it";
import CornerHover from "../CornerHover/CornerHover";


const HomeTileComponent = ({counterScalerRefs, imgRefs, p_idx, selectedIndex, activeIndex, isFromArchive, isFirstLoad, projItem, useMobileVideo, activeMetaInfo, hasSelected, defaultExit}) => {
    return (
        <>
            <div className="hpt_ovflw__wrapper">
                <motion.div 
                    className="tile_content"
                    variants={initialHPTVariants}
                    initial="initial"
                    animate="animate"
                    exit={
                        !selectedIndex ? 
                            (((p_idx - activeIndex) + 2) < 5) && (((p_idx - activeIndex) + 2) >= 0)
                            ? !window.location.href.includes("archive") || (p_idx !== activeIndex) ? "exit" : "animate"
                                : "animate"
                        : "animate"
                    }
                    custom={[
                        (p_idx > 2 && p_idx <= 4) || (p_idx == 2 && !isFromArchive),
                        p_idx-1,
                        (p_idx - activeIndex) + 2,
                        isFirstLoad,
                        p_idx == 2
                    ]}    
                >
                    <div className="hpt_counter_scaler" ref={el => counterScalerRefs[p_idx] = el}>
                        <div className="h-img-wrapper" ref={el => imgRefs.current[p_idx] = el}>
                            <ProgressiveBackgroundImg
                                key={"progressive-"+p_idx}
                                placeholderSrc={projItem.thumbnails.placeholder}
                                src={projItem.thumbnails.mobile}
                                idx={p_idx}
                                isFirefox={false}
                            />
                        </div>
                        {
                            primaryInput=="mouse" &&
                            <video
                                muted
                                autoPlay
                                loop
                                className="grid-item__hover"
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "cover",
                                    opacity: (p_idx-2) === activeMetaInfo ? 1 : ''
                                }}
                                whileHover={{
                                    opacity: 1,
                                    transition: { duration: 0.55}
                                }}
                                onMouseEnter={(e) => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.add("cursor-active")
                                    }
                                    catch{

                                    }
                                }}
                                onMouseLeave={(e) => {
                                    try{
                                        let test = document.getElementById('cursor-circle');
                                        test.classList.remove("cursor-active")
                                    }
                                    catch{

                                    }
                                }}
                            >
                                <source src={
                                    useMobileVideo ?
                                        projItem.gifStyling.mobileVideo
                                    :
                                        projItem.gifStyling.backgroundImage} 
                                type="video/mp4" />
                            </video>
                        }
                    </div>
                </motion.div>
            </div>
            {
                !hasSelected && p_idx !== selectedIndex &&
                <div className="hover-icon">
                    <div className="line_wrapper">
                        <div className="vert">
                            <div className="upper"/>
                            <div className="bottom"/>
                        </div>
                        <div className="horiz">
                            <div className="left"/>
                            <div className="right"/>
                        </div>
                    </div>
                </div>
            }
            <CornerHover 
                isSelected={(hasSelected && p_idx == selectedIndex) || (p_idx == activeIndex && defaultExit)}
                performInitial={p_idx == 2}
            />
        </>
    )
}

export default HomeTileComponent;